module.exports = __webpack_public_path__ + "static/media/biodina.90cd387e.jpg";